import { loadScript, loadCss } from "../../../utils/js/utils.js";
import { readConfigPath } from "../../../utils/js/configMgr.js";
import events from "@trinitymirrordigital/chameleon-core/src/js/events";
import { logFeature } from "../../../../scriptsCore/js/logging.js";
import * as nested from "nested-property";

const CSS_PATH = "/withnail/standalone/wraparound/scss/wraparoundAd.css";

// to see logs add ?featureDebug=ads to querystring
const log = (...args) => logFeature("ads", ...args);

let scriptLoaded = false;

export function init() {
  window.addEventListener("message", receiveMessage);
}

async function receiveMessage(e) {
  let { data } = e;
  if (e.origin !== location.origin || !data) {
    return;
  }
  log(`[INFO] secure message received: ${data}`);

  try {
    data = JSON.parse(data);
  } catch (err) {
    log(`[WARN] message could not be parsed: ${data}`);
    return;
  }

  const advert = nested.get(data, "advert");

  if (advert?.format === "wraparound") {
    window.removeEventListener("message", receiveMessage);
    if (scriptLoaded) {
      window.wraparoundAd.start(advert);
    } else {
      events.listen(window, "wraparound.reset", handleReset);
      loadWraparound(advert);
    }
  }
}

function loadWraparound(data) {
  const dispatch = () => {
    scriptLoaded = true;
    events.fire(window, "wraparound.loaded");
    window.wraparoundAd.start(data);
  };

  // TODO: use dynamic import() for this, and get rid of that global var
  Promise.all([loadScript(getScriptURL()), loadCss(getCssURL())]).then(
    dispatch
  );
}

function handleReset() {
  window.addEventListener("message", receiveMessage);
}

function getScriptURL() {
  const scriptURL = new URL(readConfigPath("currentScript"));
  const wraparoundFilename = readConfigPath(
    "advertisingConfig.wraparoundAdFilename"
  );
  const path = scriptURL.pathname
    .split("/")
    .slice(0, -1)
    .concat(wraparoundFilename)
    .join("/");
  scriptURL.pathname = path;
  return scriptURL.href;
}

function getCssURL() {
  const newURL = new URL(readConfigPath("currentScript"));
  newURL.pathname = CSS_PATH;
  return newURL.href;
}
